import { Collapseable } from "components/UI/Collapseable/Collapseable";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { useFieldArray } from "react-hook-form";

import { ConditionSection } from "./ConditionSection";
import { FormData } from "../formSchema";

interface ConditionsSectionProps {
    name: number; // index of the response handler in the responseHandlers array
    methodIndex: number; // index of the method in the methods array
}

export const ConditionsSection: FC<ConditionsSectionProps> = ({ name, methodIndex }) => {
    const { t } = usePaldockTranslation("ui.connection-creator-editor.response-conditions-section");
    const generalFormUtils = useGeneralForm<FormData>();
    const { control } = generalFormUtils;

    // Path to the responseConnectionPropertiesCheck array
    const conditionsPath =
        `methods.${methodIndex}.requestConfig.responseHandlers.${name}.responseConnectionPropertiesCheck` as const;

    const { fields, append, remove } = useFieldArray({
        control,
        name: conditionsPath,
    });

    return (
        <Collapseable
            title={t("sections.conditions.title")}
            withAddItem
            handleAddItem={() =>
                append({
                    /* default values if needed */
                })
            }
            addItemTitle={t("sections.conditions.add_item")}
            className="bg-neutral-200"
        >
            {fields.map((field, index) => (
                <ConditionSection
                    key={field.id}
                    name={index}
                    methodIndex={methodIndex}
                    responseHandlerIndex={name}
                    handleRemove={() => remove(index)}
                />
            ))}
        </Collapseable>
    );
};
